import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckBoxComponent } from './checkbox.component';
/**
 * NgModule definition for the CheckBox component.
 */
export class CheckBoxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        CheckBoxComponent
    ],
    exports: [
        CheckBoxComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CheckBoxModule_tsickle_Closure_declarations() {
/** @type {?} */
CheckBoxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckBoxModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
